import {
  Autocomplete,
  Box,
  CircularProgress,
  InputAdornment,
  Pagination,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState, useMemo } from "react";
import CustomPagination from "../CustomPagination";
import { GET_BROKER_BILLING_STATEMENT_TABLE } from "../../../constants/ApiRoute";
import { authHeader } from "../../comman/MainFunction";
import { deCryptFun, enCryptFun } from "../../comman/CustomFunction";
import API from "../../comman/API";
import sortupdownarrowIcon from "../../../images/sort_up_down_arrow.svg";
import sortuparrowIcon from "../../../images/sort_up_arrow.svg";
import sortdownarrowIcon from "../../../images/sort_down_arrow.svg";
import NoRecordFound from "../../comman/NoRecordFound";

export default function BrokerBillingStatementTable(props) {
  const { customerTab, setCustomerTab, valueTopTap } = props;

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(1);
  const rowsPerPage = 5;
  const [sortConfig, setSortConfig] = useState({
    key: "BillingHeaderID",
    direction: "asc",
  });
  const [orderBy, setOrderBy] = useState("");
  const [order, setOrder] = useState("");
  const [sortClickedTime, setSortClickedTime] = useState("");

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleSearchChange = (event, value) => {
    setSearchQuery(value);
    setPage(1); // Reset to page 1 when search query changes
  };

  const handleSort = (property) => {
    const isAsc = orderBy === property && order === "asc";

    let orderValue = isAsc ? "desc" : "asc";

    setOrder(orderValue);
    setOrderBy(property);

    if (order === "desc") {
      setOrder("");
      setOrderBy("");
    }

    if (orderBy != property) {
      setOrder("asc");
      setOrderBy(property);
    }

    setPage(1);
    setSortClickedTime(new Date().toLocaleString());

    // setSortConfig((prevState) => ({
    //   key,
    //   direction: prevState.direction === "asc" ? "desc" : "asc",
    // }));
  };

  const getSortIcon = (orderByValue) => {
    if (orderBy === orderByValue) {
      return order === "asc" ? (
        <img src={sortuparrowIcon} className="sort-table-icon-up-down" />
      ) : (
        <img src={sortdownarrowIcon} className="sort-table-icon-up-down" />
      );
    } else {
      return <img src={sortupdownarrowIcon} className="sort-table-icon-both" />;
    }
  };

  const getBrokerProjectDetails = async (custId) => {
    setLoading(true);
    let data = {
      userId: customerTab?.brokerId ? customerTab?.brokerId : custId,
      sort: order,
      orderBy: orderBy,
    };
    const config = {
      method: "GET",
      url: GET_BROKER_BILLING_STATEMENT_TABLE,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };
    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      const { status, data } = parsedResponse;
      if (status === "Success") {
        setData(data);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const handleBillingNavigate = (val) => {
    if (val.BillingHeaderID) {
      const url = `/print-dashboard-billing-statements/${val.BillingHeaderID}`;
      window.open(url, "_blank"); // Opens the URL in a new tab
    }
  };

  useEffect(() => {
    getBrokerProjectDetails(customerTab?.brokerId);
  }, [customerTab?.brokerId, order, orderBy]);

  const filteredData = useMemo(() => {
    return data.filter((item) =>
      [
        "BillingHeaderID",
        "Project",
        "Period",
        "BillingStatus",
        "Hours",
        "LastModifiedDate",
      ].some((field) =>
        String(item[field] || "")
          .toLowerCase()
          .includes(searchQuery.toLowerCase())
      )
    );
  }, [data, searchQuery]);

  const sortedAndFilteredData = useMemo(() => {
    let sortableItems = [...filteredData];
    if (sortConfig.key) {
      sortableItems.sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === "asc" ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === "asc" ? 1 : -1;
        }
        return 0;
      });
    }
    return sortableItems;
  }, [filteredData, sortConfig]);

  const paginatedData = useMemo(() => {
    return filteredData.slice(
      (page - 1) * rowsPerPage,
      (page - 1) * rowsPerPage + rowsPerPage
    );
  }, [filteredData, page]);

  const handleProjectNavigate = (val, CustID) => {
    console.log('valueTop',valueTopTap,val,customerTab,CustID)
    if (valueTopTap == "11") {
      setCustomerTab((prevState) => ({
        ...prevState,
        projectId: val,
        brokerId: "",
        
      }));
    } else {
      setCustomerTab((prevState) => ({
        ...prevState,
        projectId: val,
        customerId:CustID,

      
      }));
    }
  };
  return (
    <div>
      <Stack
        sx={{ mb: "20px" }}
        direction={{ xs: "column", sm: "row", md: "row" }}
        alignItems={{ xs: "baseline", sm: "center", md: "center" }}
        justifyContent="space-between"
      >
        <Autocomplete
          sx={{ maxWidth: "265px", width: "100%" }}
          freeSolo
          id="free-solo-2-demo"
          disableClearable
          startAdornment={
            <InputAdornment position="start">
              <span className="material-symbols-outlined">search</span>
            </InputAdornment>
          }
          options={[]}
          onInputChange={handleSearchChange}
          renderInput={(params) => (
            <TextField
              placeholder="Search"
              {...params}
              InputProps={{
                ...params.InputProps,
                type: "search",
              }}
            />
          )}
        />
      </Stack>
      <TableContainer sx={{ boxShadow: "none" }} component={Paper}>
        <Table
          // sx={{ minWidth: 650 }}
          aria-label="simple table"
        >
          <TableHead>
            <TableRow>
              <TableCell>
                <TableSortLabel
                  active={orderBy === "BillingHeaderID"}
                  direction={orderBy === "BillingHeaderID" ? order : "asc"}
                  onClick={() => handleSort("BillingHeaderID")}
                  IconComponent={() => getSortIcon("BillingHeaderID")}
                  style={
                    orderBy === "BillingHeaderID" ? { color: "#007fff" } : {}
                  }
                  // active={sortConfig.key === "BillingHeaderID"}
                  // direction={
                  //   sortConfig.key === "BillingHeaderID"
                  //     ? sortConfig.direction
                  //     : "asc"
                  // }
                  // onClick={() => handleSort("BillingHeaderID")}
                >
                  ID
                </TableSortLabel>
              </TableCell>
              <TableCell>
                <TableSortLabel
                  active={orderBy === "Project"}
                  direction={orderBy === "Project" ? order : "asc"}
                  onClick={() => handleSort("Project")}
                  IconComponent={() => getSortIcon("Project")}
                  style={orderBy === "Project" ? { color: "#007fff" } : {}}
                  // active={sortConfig.key === "Project"}
                  // direction={
                  //   sortConfig.key === "Project" ? sortConfig.direction : "asc"
                  // }
                  // onClick={() => handleSort("Project")}
                >
                  Projects
                </TableSortLabel>
              </TableCell>
              <TableCell>
                <TableSortLabel
                  active={orderBy === "Period"}
                  direction={orderBy === "Period" ? order : "asc"}
                  onClick={() => handleSort("Period")}
                  IconComponent={() => getSortIcon("Period")}
                  style={orderBy === "Period" ? { color: "#007fff" } : {}}
                  // active={sortConfig.key === "Period"}
                  // direction={
                  //   sortConfig.key === "Period" ? sortConfig.direction : "asc"
                  // }
                  // onClick={() => handleSort("Period")}
                >
                  Billing Period
                </TableSortLabel>
              </TableCell>
              <TableCell>
                <TableSortLabel
                  active={orderBy === "BillingStatus"}
                  direction={orderBy === "BillingStatus" ? order : "asc"}
                  onClick={() => handleSort("BillingStatus")}
                  IconComponent={() => getSortIcon("BillingStatus")}
                  style={
                    orderBy === "BillingStatus" ? { color: "#007fff" } : {}
                  }
                  // active={sortConfig.key === "BillingStatus"}
                  // direction={
                  //   sortConfig.key === "BillingStatus"
                  //     ? sortConfig.direction
                  //     : "asc"
                  // }
                  // onClick={() => handleSort("BillingStatus")}
                >
                  Status
                </TableSortLabel>
              </TableCell>
              <TableCell>
                <TableSortLabel
                  active={orderBy === "Hours"}
                  direction={orderBy === "Hours" ? order : "asc"}
                  onClick={() => handleSort("Hours")}
                  IconComponent={() => getSortIcon("Hours")}
                  style={orderBy === "Hours" ? { color: "#007fff" } : {}}
                  // active={sortConfig.key === "Hours"}
                  // direction={
                  //   sortConfig.key === "Hours" ? sortConfig.direction : "asc"
                  // }
                  // onClick={() => handleSort("Hours")}
                >
                  Hours
                </TableSortLabel>
              </TableCell>
              <TableCell>
                <TableSortLabel
                  active={orderBy === "LastModifiedDate"}
                  direction={orderBy === "LastModifiedDate" ? order : "asc"}
                  onClick={() => handleSort("LastModifiedDate")}
                  IconComponent={() => getSortIcon("LastModifiedDate")}
                  style={
                    orderBy === "LastModifiedDate" ? { color: "#007fff" } : {}
                  }
                  // active={sortConfig.key === "LastModifiedDate"}
                  // direction={
                  //   sortConfig.key === "LastModifiedDate"
                  //     ? sortConfig.direction
                  //     : "asc"
                  // }
                  // onClick={() => handleSort("LastModifiedDate")}
                >
                  Last Modified
                </TableSortLabel>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  <CircularProgress disableShrink />
                </TableCell>
              </TableRow>
            ) : paginatedData.length > 0 ? (
              paginatedData.map((val, index) => (
                <TableRow key={index}>
                {console.log('val',val)}

                  <TableCell
                    sx={
                      val.BillingHeaderID
                        ? {
                            color: "#007FFF !important",
                            cursor: "pointer",
                            textDecoration: "underline",
                          }
                        : {}
                    }
                    onClick={() => handleBillingNavigate(val)}
                  >
                    {val.BillingHeaderID || "-"}
                  </TableCell>
                  <TableCell
                    sx={
                      val.ProjID
                        ? {
                            color: "#007FFF !important",
                            cursor: "pointer",
                            textDecoration: "underline",
                          }
                        : {}
                    }
                    onClick={() => handleProjectNavigate(val.ProjID,val.customerId)}
                  >
                    <span style={{ wordBreak: "break-word" }}>
                      {val.Project || "-"}
                    </span>
                  </TableCell>
                  <TableCell>{val.Period || "-"}</TableCell>
                  <TableCell style={{ minWidth: "180px" }}>
                    <span
                      // className={
                      //   val.BillingStatus ? "dashboard-status-btn" : ""
                      // }
                      className={
                        val.BillingStatus == "Invoice Started"
                          ? "dashboard-status-btn"
                          : val.BillingStatus == "Statement Open"
                          ? "active-btn"
                          : val.BillingStatus == "Statement Closed"
                          ? "closed-btn"
                          : val.BillingStatus == "Invoice Closed"
                          ? "active-btn"
                          : ""
                      }
                    >
                      {val.BillingStatus || "-"}
                    </span>
                  </TableCell>
                  <TableCell>{val.Hours?.toFixed(2) || "0.00"}</TableCell>
                  <TableCell>{val.LastModifiedDate || "-"}</TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  {/* <Typography>No Record Found</Typography> */}
                  <NoRecordFound />
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
        {filteredData.length > 0 && (
          <Pagination
            sx={{ mt: "13.5px", float: "right" }}
            shape="rounded"
            // hidePrevButton
            // hideNextButton
            count={Math.ceil(filteredData.length / rowsPerPage)}
            page={page}
            onChange={handlePageChange}
          />
        )}
      </TableContainer>
    </div>
  );
}
